var elem = document.querySelector('.main-carousel');
var warriors = document.querySelector('.warriors-carousel');

if ( matchMedia('screen and (max-width: 768px)').matches ) {
  
  //TESTIMONIALS MOBILE
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    freeScroll: true,
    wrapAround: true,
    prevNextButtons: false
  });
  //FEATURED WARRIORS MOBILE
  var warriorflkty = new Flickity( warriors, {
    // options
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    selectedAttraction: 0.1,
    friction: 0.4
  });
  
} else {
  
  //TESTIMONIALS DESKTOP
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    freeScroll: true,
    wrapAround: true,
    prevNextButtons: false
  });
  //FEATURED WARRIORS DESKTOP
  var warriorflkty = new Flickity( warriors, {
    // options
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    selectedAttraction: 0.0035,
    friction: 0.15
  });
  
}




